<template>
    <TheSoundkit v-if="soundkit" :soundkit="soundkit" />
</template>

<script>
    import SoundKit from './../../models/soundkit'
    import Playlist from './../../classes/playlist'
    import Configure from './../../mixins/configure'
    import SoundKitRepository from './../../mixins/soundkit-repository'

    import TheSoundkit from "../soundkits/TheSoundkit";
    export default {
        props: ['pageId'],
        created() {
            if (this.$route.params.soundkit == undefined) {
                this.$router.push({path: '/'})
            }
            this.getSoundKit(this.$route.params.soundkit)
        },
        components: {
          TheSoundkit
        },
        data() {
            return {
                soundkit: null
            }
        },
        computed: {
            playerActive() {
                return this.$store.state.player.playing
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            isPlaying() {
                return (this.playlistManager.isPlaying(this.soundkit) && this.playerActive)
            },
            isPaused() {
                return (this.playlistManager.isPlaying(this.soundkit) && !this.playerActive)
            },
        },
        mixins: [Configure, SoundKitRepository],
        methods: {
            getSoundKit(id) {
                this.getUserSoundKit(id)
                    .then((response) => {
                        this.soundkit = new SoundKit(response.data.item)
                        this.$store.commit("singleMusicPageName", {name: this.soundkit.name})

                        this.$store.state.playlistManager.setPagePlaylist(new Playlist([this.soundkit, ...this.soundkit.samples], "soundkit-" + this.soundkit.id, "soundkit-" + this.soundkit.id));

                    })
                    .catch(() => {
                        this.$router.push({path: '/'})
                    })
            },
            play() {
                if (this.isPlaying) {
                    this.soundkit.pause()
                } else {
                    this.soundkit.play()
                }
            }
        }

    }
</script>
